/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface TaxBase
 */
export interface TaxBaseOptional {
  /**
   *
   * @type {string}
   * @memberof TaxBase
   */
  taxName?: string;
  /**
   *
   * @type {string}
   * @memberof TaxBase
   */
  taxCode?: string;
  /**
   *
   * @type {string}
   * @memberof TaxBase
   */
  taxRate?: string;
  /**
   *
   * @type {number}
   * @memberof TaxBase
   */
  taxAmountFixedCents?: number;
  /**
   *
   * @type {number}
   * @memberof TaxBase
   */
  taxMinValueCents?: number;
  /**
   *
   * @type {boolean}
   * @memberof TaxBase
   */
  taxBeforeDiscount?: boolean;
}

export interface TaxBase extends TaxBaseOptional {
  /**
   *
   * @type {string}
   * @memberof TaxBase
   */
  taxName: string;
  /**
   *
   * @type {string}
   * @memberof TaxBase
   */
  taxCode?: string;
  /**
   *
   * @type {string}
   * @memberof TaxBase
   */
  taxRate?: string;
  /**
   *
   * @type {number}
   * @memberof TaxBase
   */
  taxAmountFixedCents?: number;
  /**
   *
   * @type {number}
   * @memberof TaxBase
   */
  taxMinValueCents?: number;
  /**
   *
   * @type {boolean}
   * @memberof TaxBase
   */
  taxBeforeDiscount?: boolean;
}

export interface TaxBaseTrackedI {
  /**
   *
   * @type {string}
   * @memberof TaxBase
   */
  taxName?: string;
  taxNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof TaxBase
   */
  taxCode?: string;
  taxCodeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof TaxBase
   */
  taxRate?: string;
  taxRateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof TaxBase
   */
  taxAmountFixedCents?: number;
  taxAmountFixedCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof TaxBase
   */
  taxMinValueCents?: number;
  taxMinValueCentsIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof TaxBase
   */
  taxBeforeDiscount?: boolean;
  taxBeforeDiscountIsSet: boolean;
}

transformDatesMap.set("TaxBase", function (model: TaxBase) {});

export type TaxBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  taxName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  taxCode: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  taxRate: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  taxAmountFixedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  taxMinValueCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  taxBeforeDiscount: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var TaxBaseMeta: TaxBaseMetaI = {} as TaxBaseMetaI;
TaxBaseMeta = typeMeta("TaxBase", {
  taxName: propertyMeta("taxName", false, true, false, MetaTypesBase.string),
  taxCode: propertyMeta("taxCode", false, false, false, MetaTypesBase.string),
  taxRate: propertyMeta("taxRate", false, false, false, MetaTypesBase.string),
  taxAmountFixedCents: propertyMeta(
    "taxAmountFixedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  taxMinValueCents: propertyMeta(
    "taxMinValueCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  taxBeforeDiscount: propertyMeta(
    "taxBeforeDiscount",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = TaxBaseMeta;

registerMeta(() => {});

export class TaxBaseTracked implements TaxBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  taxName__I?: string = undefined;
  taxNameIsSet: boolean = false;
  set taxName(v: undefined | string) {
    if (v !== undefined) {
      this.taxName__I = v;
      this.taxNameIsSet = true;
    } else {
      this.taxName__I = v || undefined;
      this.taxNameIsSet = true;
    }
    this.changeTracker = true;
  }
  get taxName() {
    return this.taxName__I;
  }
  taxCode__I?: string = undefined;
  taxCodeIsSet: boolean = false;
  set taxCode(v: undefined | string) {
    if (v !== undefined) {
      this.taxCode__I = v;
      this.taxCodeIsSet = true;
    } else {
      this.taxCode__I = v || undefined;
      this.taxCodeIsSet = false;
    }
    this.changeTracker = true;
  }
  get taxCode() {
    return this.taxCode__I;
  }
  taxRate__I?: string = undefined;
  taxRateIsSet: boolean = false;
  set taxRate(v: undefined | string) {
    if (v !== undefined) {
      this.taxRate__I = v;
      this.taxRateIsSet = true;
    } else {
      this.taxRate__I = v || undefined;
      this.taxRateIsSet = false;
    }
    this.changeTracker = true;
  }
  get taxRate() {
    return this.taxRate__I;
  }
  taxAmountFixedCents__I?: number = undefined;
  taxAmountFixedCentsIsSet: boolean = false;
  set taxAmountFixedCents(v: undefined | number) {
    if (v !== undefined) {
      this.taxAmountFixedCents__I = v;
      this.taxAmountFixedCentsIsSet = true;
    } else {
      this.taxAmountFixedCents__I = v || undefined;
      this.taxAmountFixedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get taxAmountFixedCents() {
    return this.taxAmountFixedCents__I;
  }
  taxMinValueCents__I?: number = undefined;
  taxMinValueCentsIsSet: boolean = false;
  set taxMinValueCents(v: undefined | number) {
    if (v !== undefined) {
      this.taxMinValueCents__I = v;
      this.taxMinValueCentsIsSet = true;
    } else {
      this.taxMinValueCents__I = v || undefined;
      this.taxMinValueCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get taxMinValueCents() {
    return this.taxMinValueCents__I;
  }
  taxBeforeDiscount__I?: boolean = undefined;
  taxBeforeDiscountIsSet: boolean = false;
  set taxBeforeDiscount(v: undefined | boolean) {
    if (v !== undefined) {
      this.taxBeforeDiscount__I = v;
      this.taxBeforeDiscountIsSet = true;
    } else {
      this.taxBeforeDiscount__I = v || undefined;
      this.taxBeforeDiscountIsSet = false;
    }
    this.changeTracker = true;
  }
  get taxBeforeDiscount() {
    return this.taxBeforeDiscount__I;
  }
  constructor(config?: TaxBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: TaxBaseOptional,
    options?: AssignOptions,
  ): TaxBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.taxName && this.taxNameApplyFilter(optionsRequired.filter)) {
      this.taxName = config.taxName;
      if (optionsRequired.unassign) this.taxNameIsSet = false;
      else this.taxNameIsSet = true;
    }
    if (config.taxCode && this.taxCodeApplyFilter(optionsRequired.filter)) {
      this.taxCode = config.taxCode;
      if (optionsRequired.unassign) this.taxCodeIsSet = false;
      else this.taxCodeIsSet = true;
    }
    if (config.taxRate && this.taxRateApplyFilter(optionsRequired.filter)) {
      this.taxRate = config.taxRate;
      if (optionsRequired.unassign) this.taxRateIsSet = false;
      else this.taxRateIsSet = true;
    }
    if (
      config.taxAmountFixedCents &&
      this.taxAmountFixedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.taxAmountFixedCents = config.taxAmountFixedCents;
      if (optionsRequired.unassign) this.taxAmountFixedCentsIsSet = false;
      else this.taxAmountFixedCentsIsSet = true;
    }
    if (
      config.taxMinValueCents &&
      this.taxMinValueCentsApplyFilter(optionsRequired.filter)
    ) {
      this.taxMinValueCents = config.taxMinValueCents;
      if (optionsRequired.unassign) this.taxMinValueCentsIsSet = false;
      else this.taxMinValueCentsIsSet = true;
    }
    if (
      config.taxBeforeDiscount &&
      this.taxBeforeDiscountApplyFilter(optionsRequired.filter)
    ) {
      this.taxBeforeDiscount = config.taxBeforeDiscount;
      if (optionsRequired.unassign) this.taxBeforeDiscountIsSet = false;
      else this.taxBeforeDiscountIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): TaxBaseTrackedI {
    const cloned = {} as TaxBaseTrackedI;
    if (
      this.taxNameIsSetDeep() &&
      this.taxNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxNameIsSet = true;
      cloned.taxName = this.taxName;
    } else {
      //cloned.taxNameIsSet = false
    }
    if (
      this.taxCodeIsSetDeep() &&
      this.taxCodeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxCodeIsSet = true;
      cloned.taxCode = this.taxCode;
    } else {
      //cloned.taxCodeIsSet = false
    }
    if (
      this.taxRateIsSetDeep() &&
      this.taxRateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxRateIsSet = true;
      cloned.taxRate = this.taxRate;
    } else {
      //cloned.taxRateIsSet = false
    }
    if (
      this.taxAmountFixedCentsIsSetDeep() &&
      this.taxAmountFixedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxAmountFixedCentsIsSet = true;
      cloned.taxAmountFixedCents = this.taxAmountFixedCents;
    } else {
      //cloned.taxAmountFixedCentsIsSet = false
    }
    if (
      this.taxMinValueCentsIsSetDeep() &&
      this.taxMinValueCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxMinValueCentsIsSet = true;
      cloned.taxMinValueCents = this.taxMinValueCents;
    } else {
      //cloned.taxMinValueCentsIsSet = false
    }
    if (
      this.taxBeforeDiscountIsSetDeep() &&
      this.taxBeforeDiscountApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxBeforeDiscountIsSet = true;
      cloned.taxBeforeDiscount = this.taxBeforeDiscount;
    } else {
      //cloned.taxBeforeDiscountIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): TaxBaseTrackedI {
    if (!this.taxNameApplyFilter(filter)) this.taxNameIsSet = false;

    if (!this.taxCodeApplyFilter(filter)) this.taxCodeIsSet = false;

    if (!this.taxRateApplyFilter(filter)) this.taxRateIsSet = false;

    if (!this.taxAmountFixedCentsApplyFilter(filter))
      this.taxAmountFixedCentsIsSet = false;

    if (!this.taxMinValueCentsApplyFilter(filter))
      this.taxMinValueCentsIsSet = false;

    if (!this.taxBeforeDiscountApplyFilter(filter))
      this.taxBeforeDiscountIsSet = false;

    return this;
  }
  taxNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(TaxBaseMeta.taxName, TaxBaseMeta, this.taxName, this);
  }
  taxNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.taxNameIsSet && this.taxNameApplyFilter(filter)) return true;

    return false;
  }
  taxCodeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(TaxBaseMeta.taxCode, TaxBaseMeta, this.taxCode, this);
  }
  taxCodeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.taxCodeIsSet && this.taxCodeApplyFilter(filter)) return true;

    return false;
  }
  taxRateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(TaxBaseMeta.taxRate, TaxBaseMeta, this.taxRate, this);
  }
  taxRateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.taxRateIsSet && this.taxRateApplyFilter(filter)) return true;

    return false;
  }
  taxAmountFixedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TaxBaseMeta.taxAmountFixedCents,
      TaxBaseMeta,
      this.taxAmountFixedCents,
      this,
    );
  }
  taxAmountFixedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.taxAmountFixedCentsIsSet &&
      this.taxAmountFixedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  taxMinValueCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TaxBaseMeta.taxMinValueCents,
      TaxBaseMeta,
      this.taxMinValueCents,
      this,
    );
  }
  taxMinValueCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.taxMinValueCentsIsSet && this.taxMinValueCentsApplyFilter(filter))
      return true;

    return false;
  }
  taxBeforeDiscountApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TaxBaseMeta.taxBeforeDiscount,
      TaxBaseMeta,
      this.taxBeforeDiscount,
      this,
    );
  }
  taxBeforeDiscountIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.taxBeforeDiscountIsSet &&
      this.taxBeforeDiscountApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.taxNameIsSetDeep(filter)) return true;
    if (this.taxCodeIsSetDeep(filter)) return true;
    if (this.taxRateIsSetDeep(filter)) return true;
    if (this.taxAmountFixedCentsIsSetDeep(filter)) return true;
    if (this.taxMinValueCentsIsSetDeep(filter)) return true;
    if (this.taxBeforeDiscountIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
